export const MAX_TEACHING_DESCRIPTION_LENGTH = 5000
export const MIN_WORKLOAD = 0.5
export const MAX_WORKLOAD = 999.9
export const MIN_WEIGHT = 1
export const MAX_WEIGHT = 100

export const TEACHING_ERRORS = {
  NOT_FOUND: 'Enseignement non trouvé',
  NOT_ACCESSIBLE: 'Enseignement non accessible',
  INVALID_STATE: 'État invalide',
  INVALID_SUBJECT: 'Matière invalide',
  INVALID_CLASS_OR_GROUP: 'Classe ou groupe requis',
  CREATION_FAILED: 'Erreur lors de la création',
  UPDATE_FAILED: 'Erreur lors de la mise à jour',
  DELETE_FAILED: 'Erreur lors de la suppression',
  INVALID_LESSON_IDS: 'IDs de leçons invalides',
  INVALID_CHAPTER_IDS: 'IDs de chapitres invalides',
} as const

export const TEACHING_OPERATIONS = {
  CREATE: 'create_teaching',
  FIND_ALL: 'findMany_teachings',
  FIND_ONE: 'get_teaching',
  FIND_BY_LESSON: 'findByLesson_teachings',
  FIND_BY_CHAPTER: 'findByChapter_teachings',
  UPDATE: 'update_teaching',
  DELETE: 'delete_teaching',
  SET_STATE: 'set_teaching_state',
} as const

export const TEACHING_LOG_MESSAGES = {
  CREATING: (userId: string) => `[User ${userId}] Creating teaching`,
  CREATED: (id: string) => `Teaching created: ${id}`,
  UPDATING: (userId: string, id: string) =>
    `[User ${userId}] Updating teaching: ${id}`,
  UPDATED: (id: string) => `Teaching updated: ${id}`,
  DELETING: (userId: string, id: string) =>
    `[User ${userId}] Deleting teaching: ${id}`,
  DELETED: (id: string) => `Teaching deleted: ${id}`,
  STATE_CHANGED: (id: string, state: string, userId: string) =>
    `Teaching ${id} state changed to ${state} by user ${userId}`,
  FOUND: (count: number, userId: string) =>
    `Found ${count} teachings for user ${userId}`,
  FOUND_PAGINATED: (count: number, total: number, userId: string) =>
    `Found ${count}/${total} teachings for user ${userId} (cursor pagination)`,
} as const

export const TEACHING_ERROR_CONTEXTS = {
  CREATE: 'create teaching',
  FETCH_ALL: 'fetch teachings',
  FETCH_PAGINATED: 'fetch paginated teachings',
  FETCH_ONE: 'fetch teaching',
  UPDATE: 'update teaching',
  DELETE: 'delete teaching',
  SET_STATE: 'set teaching state',
} as const

export const TEACHING_POLICY_ACTIONS = {
  CREATE: 'teaching:create',
  VIEW: 'teaching:view',
  UPDATE: 'teaching:update',
  DELETE: 'teaching:delete',
  SET_STATE: 'teaching:setState',
} as const
